import React from 'react';

import { AUTH_HREF } from '@pages/public/constants';
import ButtonPublic from '@shared/components/ui/ButtonPublic';
import { FAQ_ITEMS } from '../../constants';

import styles from './styles.module.css';

import { track } from '@/shared/analytics/track';
import { useGlobalSettings } from '@/shared/hooks/useGlobalSettings';

const handleBookACallClick = (): void => {
  track('book_a_call_clicked', { location: 'faq' });
};

const FAQ: React.FC = () => {
  const { bookAMeetingUrl } = useGlobalSettings();

  return (
    <section className={styles.faq} id="faq">
      <div className={styles.shell}>
        <div className={styles.grid}>
          <div className={styles.side}>
            <div className={styles.eyebrow}>Frequently asked</div>
            <h2 className={styles.heading}>Answers from our partner team.</h2>
            <p className={styles.lede}>
              The fastest way to a real answer is a 30-minute call with our team
              to explore your resale goals.
            </p>
            <div className={styles.actions}>
              <ButtonPublic
                as="a"
                href={bookAMeetingUrl}
                target="_blank"
                variant="primary"
                onClick={handleBookACallClick}
              >
                Book a 30-min call
              </ButtonPublic>
              <ButtonPublic as="a" href={AUTH_HREF} variant="secondary">
                Sign in to Client Portal →
              </ButtonPublic>
            </div>
          </div>

          <div className={styles.list}>
            {FAQ_ITEMS.map((item) => (
              <details
                key={item.question}
                open={item.defaultOpen}
                className={styles.item}
              >
                <summary className={styles.summary}>{item.question}</summary>
                <div className={styles.answer}>{item.answer}</div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
